import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 55 55"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M27.5 5.156A22.344 22.344 0 1 0 49.844 27.5 22.37 22.37 0 0 0 27.5 5.156m9.81 18.404L25.278 35.59a1.72 1.72 0 0 1-2.431 0l-5.157-5.156a1.72 1.72 0 0 1 2.432-2.432l3.94 3.942 10.816-10.817a1.72 1.72 0 0 1 2.432 2.432"
    }, null, -1)
  ])))
}
export default { render: render }